module.exports = "/assets/b39ab4ad9130214577fff7aad4c89a97.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/M5.png
// module id = 2726
// module chunks = 0